import { Controller } from '@hotwired/stimulus'

// Reloads the page as soon as it connects. Broadcast into a page (e.g. via a
// Turbo Stream append) to make it re-request its own URL — used by the
// edition-PDF pending page, whose URL serves the PDF once rendering finishes.
export default class extends Controller {
  connect() {
    window.location.reload()
  }
}
